import { logout, refresh, uuid } from "@/services/helpers";

import dayjs from "@/services/dayjs";

export default {
  install(Vue) {

    Vue.prototype.$laravel = window.Laravel;
    Vue.prototype.$laravel.route = window.route;

    Vue.dayjs = dayjs;
    Vue.prototype.$dayjs = dayjs;

    // Street line for display: Avenue -> Av., Boulevard -> Boul., Chemin -> Ch.
    Vue.prototype.$shortStreet = (street) =>
      (street || "")
        .replace(/\bAvenue\b/i, "Av.")
        .replace(/\bBoulevard\b/i, "Boul.")
        .replace(/\bChemin\b/i, "Ch.");

    // Compact date for the lists, standard locale abbreviations:
    // "1er janv. 2026", "15 févr. 2026" (en: "1st Jan 2026")
    Vue.prototype.$shortDate = (value, utc = true) => {
      if (!value) {
        return "";
      }
      const date = utc ? dayjs.utc(value) : dayjs(value);

      if (!date.isValid()) {
        return "";
      }
      // "Do" needs the advancedFormat plugin; only the 1st is ordinal anyway
      const lang = (document.documentElement.lang || "fr").startsWith("en") ? "en" : "fr";
      const day = date.date() === 1 ? (lang === "fr" ? "1er" : "1st") : String(date.date());

      return day + " " + date.format("MMM YYYY");
    };

    Vue._ = _;
    Vue.prototype._ = _;
    Vue.prototype.$_ = _;

    Vue.prototype.$refresh = refresh;
    Vue.prototype.$logout = logout;
    Vue.prototype.$uuid = uuid;

    Vue.prototype.$roleCan = (roles =  []) => {
      let can = false;
      for (const role of roles) {
        if (window.Laravel.user.role === role) {
          can = true;
          break;
        }
      }
      return can;
    };

    Vue.prototype.$rolePermission = (actions = []) => {

      let newActions = [];

      for (const action of actions) {
        const method = action.method;

        if (!method) {
          action.method = "create";
        }

        if (action.method == "update")
        {
          if (action.data.can && Object.prototype.hasOwnProperty.call(action.data.can, method))
          {
            newActions.push(action);
          }
        } else {

          if (!action.resource || !window.Laravel.user.permissions) {
            return [];
          }

          if (window.Laravel.user.permissions[action.resource] && window.Laravel.user.permissions[action.resource][action.method]) {
            newActions.push(action);
          }
        }
      }

      return newActions;
    };
  }
};
